import useAppGlobal from "src/context/useAppGlobal";
import { v4 as uuid } from "uuid";
import FinanceDetailDialog from "../FinanceDetailDialog";
import useQueryParams from "src/hooks/useQueryParams";
import PayTheDebtDialog from "../PayTheDebtDialog";
export default function useAllFinanceAction({ wHouseId }) {
  const [option] = useQueryParams();
  const { handleOpenDialog } = useAppGlobal();

  const hanldeDetail = (item) => {
    handleOpenDialog({
      title: "Chi tiết công nợ",
      size: "sm",
      content: (
        <FinanceDetailDialog
          id={item?._id}
          wHouseId={wHouseId}
        />
      ),
    });
  };

  const handlePayTheDebt = (item) => {
    handleOpenDialog({
      title: "Thanh toán nợ",
      content: (
        <PayTheDebtDialog
          item={item}
          wHouseId={wHouseId}
        />
      ),
      size: "sm",
    });
  };
  const action = [
    {
      id: uuid(),
      title: "Xem chi tiết",
      onClick: (item) => hanldeDetail(item),
      type: "default",
    },
    {
      id: uuid(),
      title: "Thanh toán",
      onClick: (item) => handlePayTheDebt(item),
      type: "default",
      display: option?.tab === "Unpaid" ? true : false,
    },
  ];
  return action;
}
